import { render } from "./QuranSajdaCard.vue?vue&type=template&id=6292355e"
import script from "./QuranSajdaCard.vue?vue&type=script&lang=js"
export * from "./QuranSajdaCard.vue?vue&type=script&lang=js"
script.render = render

export default script